@switch (type) {
  @case ('PRODUCTION') {
    <div [ngClass]="{ 'pointer-events-none opacity-50': isTimesheetApproved }">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ label }}</mat-label>
        <input
          matInput
          type="number"
          placeholder="0.00"
          min="0"
          [formControl]="value"
          (blur)="trimDecimal($event)"
          (keypress)="onlyNumberOrDecimal($event.key)"
        />
      </mat-form-field>
    </div>
  }
  @case ('TEXT') {
    <div [ngClass]="{ 'pointer-events-none opacity-50': isTimesheetApproved }">
      <mat-form-field appearance="outline" class="flex w-full min-w-[300px]">
        <mat-label>{{ label }}</mat-label>
        <textarea
          #autosize="cdkTextareaAutosize"
          class="leading-5"
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="1"
          cdkAutosizeMaxRows="4"
          [formControl]="value"
        ></textarea>
      </mat-form-field>
    </div>
  }
  @case ('BOOLEAN') {
    <div class="w-full pb-[1.25em]" [ngClass]="{ 'pointer-events-none opacity-50': isTimesheetApproved }">
      <mat-checkbox [formControl]="value">
        <span class="pl-1">{{ label }}</span>
      </mat-checkbox>
    </div>
  }
  @case ('SELECT') {
    <div [ngClass]="{ 'pointer-events-none opacity-50': isTimesheetApproved }">
      <mat-form-field appearance="outline" class="w-full" floatLabel="auto">
        <mat-label>{{ label }}</mat-label>
        <mat-select [formControl]="value">
          @for (option of options; track option) {
            <mat-option [value]="option.value">
              {{ option.display }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
  }
  @case ('SHORT_TEXT') {
    <div [ngClass]="{ 'pointer-events-none opacity-50': isTimesheetApproved }">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ label }}</mat-label>
        <input matInput type="text" maxlength="15" [formControl]="value" />
      </mat-form-field>
    </div>
  }
  @case ('TIME') {
    <div [ngClass]="{ 'pointer-events-none opacity-50': isTimesheetApproved }">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>{{ label }}</mat-label>
        <input matInput type="time" [formControl]="value" />
      </mat-form-field>
    </div>
  }
  @default {
    <div class="text-center">&mdash;</div>
  }
}
